// test717
(717 && 0);
